
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useMockRadioData } from '@/hooks/useMockRadioData';

const RadioWorldMap: React.FC = () => {
  const { worldMapData } = useMockRadioData();
  const [selectedTrack, setSelectedTrack] = useState<string>("all");
  const [selectedTimeframe, setSelectedTimeframe] = useState<string>("month");

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Global Radio Spins</CardTitle>
          <CardDescription>Visualize your radio plays across the world</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col sm:flex-row items-start gap-4 mb-6">
            <div className="w-full sm:w-1/3">
              <Label htmlFor="track">Track</Label>
              <Select
                value={selectedTrack}
                onValueChange={setSelectedTrack}
              >
                <SelectTrigger id="track">
                  <SelectValue placeholder="Select Track" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Tracks</SelectItem>
                  {worldMapData.tracks.map((track, index) => (
                    <SelectItem key={index} value={track.id}>{track.title}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="w-full sm:w-1/3">
              <Label htmlFor="timeframe">Time Period</Label>
              <Select
                value={selectedTimeframe}
                onValueChange={setSelectedTimeframe}
              >
                <SelectTrigger id="timeframe">
                  <SelectValue placeholder="Select Timeframe" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="week">Last 7 Days</SelectItem>
                  <SelectItem value="month">Last 30 Days</SelectItem>
                  <SelectItem value="quarter">Last 90 Days</SelectItem>
                  <SelectItem value="year">Last 365 Days</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="w-full sm:w-1/3">
              <Label htmlFor="search">Search Location</Label>
              <Input id="search" placeholder="Search by city, country, or station" />
            </div>
          </div>

          <div className="border rounded-lg p-4 flex items-center justify-center h-[400px]">
            <div className="text-center">
              <p className="text-muted-foreground">Interactive world map with radio station pins would be displayed here.</p>
              <p className="text-muted-foreground text-sm mt-2">This feature provides visualization of stations playing your tracks across the globe.</p>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            {worldMapData.highlights.map((highlight, index) => (
              <div key={index} className="border rounded-lg p-4">
                <h3 className="font-medium">{highlight.region}</h3>
                <p className="text-2xl font-bold">{highlight.spins}</p>
                <p className="text-sm text-muted-foreground">
                  {highlight.stations} stations, {highlight.trend}% {highlight.trend > 0 ? 'increase' : 'decrease'}
                </p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RadioWorldMap;
